import { PositionType } from '../../../lib/defs/types';
import { DartAnimation } from '../../animations/DartAnimation';
import { setBlockEntityViewLayer } from '../../entities/BlockEntity';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { getCollisionTracker } from '../../util/CollisionTracker';
import { IEffect } from './IEffect';

// types
//-----------------------------------------------------------------------------
export type DartEffectOptions = {
  position: PositionType;
};

/*
    dart booster effect
*/
export class DartEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  // state
  private readonly _collisionTracker = getCollisionTracker();

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: DartEffectOptions) {
    this._scene = scene;
    this._position = options.position;
  }

  public static assets(): string[] {
    return DartAnimation.assets();
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // run dart
    await this._runDart();
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _runDart() {
    // create animation
    const animation = new DartAnimation(this._position);
    // register events
    animation.onImpact = () => this._onDartImpact();
    // spawn animation as overlay entity
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      { width: 1, height: 1 },
      () => animation,
    );
    // Send the hammer to the foreground if we're using the new visuals.
    setBlockEntityViewLayer(this._scene, entity, 'foreground');

    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }

  // private: events
  //-------------------------------------------------------------------------
  private _onDartImpact() {
    // attack any blocks at this position as a booster
    this._collisionTracker.collideAt(
      this._scene.sessionEntity.c.map,
      this._position,
      'attack',
      {
        type: 'booster',
      },
    );
  }
}
